import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import type React from "react";
import { useState } from "react";
import { tagColors } from "../utils/sectionColors";
import { useTagColorsStyles } from "../styles/sectionColorsStyles";

interface SwatchProps {
	color: string;
	onSelect: (color: string) => void;
	onClose: () => void;
}

const Swatch = ({ color, onSelect, onClose }: SwatchProps) => {
	const classes = useTagColorsStyles();
	const handleClick = () => {
		onSelect(color);
		onClose();
	};

	return (
		<div
			className={classes.swatch}
			style={{ backgroundColor: color }}
			onClick={handleClick}
		/>
	);
};

interface Props {
	onChange: (color: string) => void;
	color: string;
	label?: string;
}

export const ColorPicker = ({ onChange, color, label }: Props) => {
	const classes = useTagColorsStyles();
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? "simple-popover" : undefined;

	return (
		<div>
			<Button
				aria-describedby={id}
				variant="outlined"
				onClick={handleClick}
				sx={{
					backgroundColor: color,
					width: "100%",
					height: "40px",
					minWidth: "100%",
					paddingLeft: "50px",
					border: "1px solid rgba(0, 0, 0, 0.23)",
					"&:hover": {
						border: "1px solid rgba(0, 0, 0, 0.87)",
					},
				}}
			/>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				<div className={classes.popover}>
					{tagColors.map((color) => (
						<Swatch
							key={color}
							color={color}
							onSelect={onChange}
							onClose={handleClose}
						/>
					))}
				</div>
			</Popover>
		</div>
	);
};
